// Autogenerated file
export const tripSheetCommunicationTypesEnum = {
    City: "City",
    Suburban: "Suburban",
    Intercity: "Intercity",
};
export const tripSheetCommunicationTypes = [
    { label: "городское", value: "City" },
    { label: "пригородное", value: "Suburban" },
    { label: "междугороднее", value: "Intercity" },
];
